import { Link } from 'react-router-dom';
import { Mail, Send } from 'lucide-react';
import { Logo } from './Logo';

export const Footer = (): React.JSX.Element => {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-ink-800 bg-ink-900">
      <div className="container py-12 flex flex-col items-center text-center gap-4 text-sm">
        <Logo />
        <p className="text-ink-400 max-w-md">
          Автоматизация принятия решений — цифровые продукты для онлайн-бизнеса. С 2017 строим для
          себя. С 2026 — открываем для других.
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-6">
          <a
            href="https://t.me/sup_eion"
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-2 text-ink-300 hover:text-white transition-colors"
          >
            <Send className="h-4 w-4" /> Чат поддержки в Telegram
          </a>
          <a
            href="mailto:support@e-ion.ru"
            className="flex items-center gap-2 text-ink-300 hover:text-white transition-colors"
          >
            <Mail className="h-4 w-4" /> support@e-ion.ru
          </a>
        </div>
      </div>

      <div className="border-t border-ink-800">
        <div className="container py-5 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-ink-400">
          <div>© {year} ИП Ратушная Т. А. · ОГРНИП 319774600581996 · ИНН 519055872906</div>
          <div className="flex items-center gap-5">
            <Link to="/legal/privacy" className="hover:text-white transition-colors">
              Политика конфиденциальности
            </Link>
            <Link to="/legal/terms" className="hover:text-white transition-colors">
              Условия использования
            </Link>
            <Link to="/legal/offer" className="hover:text-white transition-colors">
              Договор-оферта
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
